import { useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import _ from "underscore";

export const useEmployeePerformance = () => {

    const { selectedEmployee } = useEmployeFilter();
    const today = new Date();
    const [date, setDate] = useState(today);
    const [selectedYear, setSelectedYear] = useState(today?.getFullYear());
    const [months, setMonths] = useState(null);
    const [loader, setLoader] = useState(false);
    const calendarWrapperRef = useRef(null);

    useEffect(() => {
        setSelectedYear(date?.getFullYear());
    }, [date])

    // useEffect(() => {
    //     setShowMonths(true);
    //     const calendarRoot = document.querySelector('.employee-perf-calendar');

    //     const observer = new MutationObserver(() => {
    //         const yearPicker = document.querySelector('.p-yearpicker');

    //         if (yearPicker) {
    //             setShowMonths(false);
    //         }

    //         const yearCells = document.querySelectorAll('.p-yearpicker .p-yearpicker-year');
    //         yearCells.forEach(cell => {
    //             cell.removeEventListener('click', yearClickHandler);
    //             cell.addEventListener('click', yearClickHandler);
    //         });
    //     });

    //     const yearClickHandler = (e) => {
    //         const selectedYear = parseInt(e.target.textContent?.slice(0,4));
    //         setSelectedYear(selectedYear);
    //         setShowMonths(true);
    //     };

    //     if (calendarRoot) {
    //         observer.observe(calendarRoot, { childList: true, subtree: true });
    //     }

    //     return () => {
    //         observer.disconnect();
    //         document.querySelectorAll('.p-yearpicker .p-yearpicker-year')
    //             .forEach(cell => cell.removeEventListener('click', yearClickHandler));
    //     };
    // }, []);

     useEffect(() => {
        const timer = setTimeout(() => {
            if (calendarWrapperRef.current) {
                const yearBtn = calendarWrapperRef.current.querySelector('.p-datepicker-year');
                if (yearBtn) {
                    yearBtn.style.pointerEvents = 'none';
                    yearBtn.style.cursor = 'default';
                }
            }
        }, 0);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        selectedEmployee?.user_code && getEmployeePerformanceData();
    }, [selectedEmployee?.user_code, selectedYear])

    const getEmployeePerformanceData = async () => {
        try {
            setLoader(true);
            const payload = {
                year: selectedYear,
                requested_user_code: selectedEmployee?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETWORKPERFORMANCEMONTHLYSUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.workperformance_monthly_summary;
                const monthData = [
                    { month: "Jan", classname: "", percent: null },
                    { month: "Feb", classname: "", percent: null },
                    { month: "Mar", classname: "", percent: null },
                    { month: "Apr", classname: "", percent: null },
                    { month: "May", classname: "", percent: null },
                    { month: "Jun", classname: "", percent: null },
                    { month: "Jul", classname: "", percent: null },
                    { month: "Aug", classname: "", percent: null },
                    { month: "Sep", classname: "", percent: null },
                    { month: "Oct", classname: "", percent: null },
                    { month: "Nov", classname: "", percent: null },
                    { month: "Dec", classname: "", percent: null },
                ];
                data?.forEach((item) => {
                    if (item?.tv_month !== null && item?.tv_month !== undefined) {
                        const percent = item?.bid_accuracy;
                        let obj = {
                            classname: "",
                            percent: null
                        }
                        if (percent !== null) {
                            if (percent > 105) {
                                obj.classname = "emp-perf-red";
                            } else if (percent <= 105 && percent >= 95) {
                                obj.classname = "emp-perf-green";
                            } else if (percent < 95 && percent >= 0) {
                                obj.classname = "emp-perf-orange";
                            }
                            obj.percent = parseInt(percent);
                        } else if (item?.alloted_bid_seconds !== null && item?.alloted_bid_seconds !== undefined) {
                            obj = {
                                classname: "",
                                percent: 0
                            }
                        }
                        monthData[item?.tv_month - 1].classname = obj.classname;
                        monthData[item?.tv_month - 1].percent = obj.percent;
                    }
                })
                setMonths(monthData);
                setLoader(false);
            }
        } catch (error) {
            console.error("Error getting employee performance data: ", error);
            setLoader(false);
        }
    }

    return useMemo(() => ({
        date, setDate, months, calendarWrapperRef, loader
    }), [date, setDate, months, calendarWrapperRef, loader])
}